import { useState } from "react";
import { MessageCircle } from "lucide-react";
import { LINKS } from "@/data/site";

export const WhatsAppButton = () => {
  const [hover, setHover] = useState(false);
  return (
    <a
      href={LINKS.whatsapp}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-community-btn"
      aria-label="Join our WhatsApp community"
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      className="fixed bottom-6 right-6 z-40 flex items-center"
    >
      <span className="relative flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-[0_10px_30px_rgba(37,211,102,0.5)] transition-transform hover:scale-110">
        <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-40" />
        <MessageCircle className="relative h-7 w-7" />
      </span>
      <span
        className={`ml-3 overflow-hidden whitespace-nowrap rounded-full bg-ink-surface border border-white/10 text-white text-sm font-semibold shadow-lg transition-all duration-300 ${hover ? "max-w-[220px] px-4 py-2.5 opacity-100" : "max-w-0 px-0 py-2.5 opacity-0"}`}
      >
        Join WhatsApp Community
      </span>
    </a>
  );
};
